<div class="p-3">
    <h1 mat-dialog-title>Reverify Guest</h1>
    <div mat-dialog-content class="my-2">
        <p><b>Warning</b>: All existing verification results, including changes made manually, will be overridden by new results. Are you sure?</p>
    </div>
    <div class="mt-4 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
            <mat-icon>redo</mat-icon>
            Reverify Guest
        </button>
    </div>
</div>